var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.608,
    height: 42.608,
    viewBox: "0 0 42.608 42.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1060",
    "data-name": "Trazado 1060",
    d: "M489.3-728.06a20.3,20.3,0,0,1-20.3,20.3,20.3,20.3,0,0,1-20.3-20.3,20.3,20.3,0,0,1,20.3-20.3A20.3,20.3,0,0,1,489.3-728.06Z",
    transform: "translate(-448.694 748.364)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66",
    transform: "translate(8.586 8.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1061",
    "data-name": "Trazado 1061",
    d: "M535.768-667.366c3.134,0,3.506.012,4.743.068a6.5,6.5,0,0,1,2.18.4,3.641,3.641,0,0,1,1.35.878,3.628,3.628,0,0,1,.878,1.349,6.505,6.505,0,0,1,.4,2.18c.057,1.238.068,1.609.068,4.744s-.012,3.506-.068,4.743a6.5,6.5,0,0,1-.4,2.18,3.625,3.625,0,0,1-.878,1.349,3.64,3.64,0,0,1-1.35.879,6.514,6.514,0,0,1-2.18.4c-1.238.056-1.609.068-4.743.068s-3.506-.012-4.744-.068a6.513,6.513,0,0,1-2.18-.4,3.632,3.632,0,0,1-1.349-.879,3.613,3.613,0,0,1-.878-1.349,6.507,6.507,0,0,1-.4-2.18c-.057-1.238-.068-1.609-.068-4.743s.012-3.506.068-4.744a6.508,6.508,0,0,1,.4-2.18,3.617,3.617,0,0,1,.878-1.349,3.633,3.633,0,0,1,1.349-.878,6.5,6.5,0,0,1,2.18-.4c1.238-.056,1.609-.068,4.744-.068m0-2.115c-3.188,0-3.588.013-4.84.071a8.624,8.624,0,0,0-2.85.546A5.744,5.744,0,0,0,526-667.51a5.75,5.75,0,0,0-1.354,2.079,8.6,8.6,0,0,0-.545,2.849c-.058,1.252-.071,1.652-.071,4.84s.014,3.587.071,4.84a8.6,8.6,0,0,0,.545,2.849A5.751,5.751,0,0,0,526-647.974a5.751,5.751,0,0,0,2.079,1.354,8.62,8.62,0,0,0,2.85.545c1.252.057,1.651.071,4.84.071s3.588-.013,4.84-.071a8.617,8.617,0,0,0,2.849-.545,5.752,5.752,0,0,0,2.079-1.354,5.75,5.75,0,0,0,1.354-2.079,8.605,8.605,0,0,0,.546-2.849c.057-1.252.071-1.652.071-4.84s-.014-3.588-.071-4.84a8.605,8.605,0,0,0-.546-2.849,5.749,5.749,0,0,0-1.354-2.079,5.745,5.745,0,0,0-2.079-1.354,8.621,8.621,0,0,0-2.849-.546c-1.252-.057-1.652-.071-4.84-.071",
    transform: "translate(-524.029 669.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1062",
    "data-name": "Trazado 1062",
    d: "M580.166-619.371a6.027,6.027,0,0,0-6.028,6.028,6.027,6.027,0,0,0,6.028,6.028,6.027,6.027,0,0,0,6.027-6.028,6.027,6.027,0,0,0-6.027-6.028m0,9.941a3.914,3.914,0,0,1-3.913-3.913,3.913,3.913,0,0,1,3.913-3.913,3.913,3.913,0,0,1,3.913,3.913,3.913,3.913,0,0,1-3.913,3.913",
    transform: "translate(-568.427 625.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1063",
    "data-name": "Trazado 1063",
    d: "M672.465-632.419a1.409,1.409,0,0,1-1.409,1.409,1.409,1.409,0,0,1-1.409-1.409,1.409,1.409,0,0,1,1.409-1.409,1.409,1.409,0,0,1,1.409,1.409",
    transform: "translate(-653.052 637.891)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6c393514fbce1d6e6545b8f4fe38599e.svg";
export { ForwardRef as ReactComponent };